"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NUFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_176)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_176`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H36V24.0003H0V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H18V11.9998H0V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.125 -0.000244141H7.87501V4.87474H0V7.12474H7.87501V11.9998H10.125V7.12474H18V4.87474H10.125V-0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 -0.000244141V1.06028L4.03432 3.74981H5.62501L0 -0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 1.59047V3.74991H3.23923L0 1.59047ZM6.75001 0V3.4392L1.59103 0H6.75001Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 -0.000244141V1.06028L13.9657 3.74981H12.375L18 -0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 1.59047V3.74991H14.7608L18 1.59047ZM11.25 0V3.4392L16.409 0H11.25Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 -0.000244141V1.06028L4.03432 3.74981H5.62501L0 -0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 1.59047V3.74991H3.23923L0 1.59047ZM6.75001 0V3.4392L1.59103 0H6.75001Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 -0.000244141V1.06028L13.9657 3.74981H12.375L18 -0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 1.59047V3.74991H14.7608L18 1.59047ZM11.25 0V3.4392L16.409 0H11.25Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 11.9998V10.9394L4.03432 8.24976H5.62501L0 11.9998Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 10.4093V8.24976H3.23923L0 10.4093ZM6.75001 11.9996V8.56047L1.59103 11.9996H6.75001Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 11.9998V10.9394L13.9657 8.24976H12.375L18 11.9998Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 10.4093V8.24976H14.7608L18 10.4093ZM11.25 11.9996V8.56047L16.409 11.9996H11.25Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.00002 7.59062C9.87868 7.59062 10.591 6.87832 10.591 5.99965C10.591 5.12099 9.87868 4.40869 9.00002 4.40869C8.12136 4.40869 7.40906 5.12099 7.40906 5.99965C7.40906 6.87832 8.12136 7.59062 9.00002 7.59062Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.00008 4.87473L9.27922 5.73409H10.183L9.45191 6.26537L9.73112 7.12473L9.00008 6.59359L8.26897 7.12473L8.54825 6.26537L7.81714 5.73409H8.72087L9.00008 4.87473ZM9.00008 9.45489L9.1663 9.96662H9.7044L9.26917 10.2829L9.43539 10.7946L9.00008 10.4784L8.56478 10.7946L8.73099 10.2829L8.29576 9.96662H8.83379L9.00008 9.45489ZM9.00008 1.20483L9.1663 1.71657H9.7044L9.26917 2.03283L9.43539 2.54457L9.00008 2.2283L8.56478 2.54457L8.73099 2.03283L8.29576 1.71657H8.83379L9.00008 1.20483ZM13.9171 5.32986L14.0834 5.84153H14.6215L14.1861 6.15786L14.3524 6.66967L13.9171 6.3534L13.4818 6.66967L13.6481 6.15786L13.2128 5.84153H13.7508L13.9171 5.32986ZM4.08305 5.32986L4.24927 5.84153H4.78737L4.35207 6.15786L4.51829 6.66967L4.08305 6.3534L3.64775 6.66967L3.81404 6.15786L3.37866 5.84153H3.91676L4.08305 5.32986Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_176`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NUFlag };
